/**
 * Lazy-loaded live / participant live route elements.
 */
import React from 'react';

export const LiveForum = React.lazy(() =>
  import('@/pages/live/forum').then((m) => ({ default: m.LiveForum }))
);
export const LiveRoom = React.lazy(() =>
  import('@/pages/live/live-room').then((m) => ({ default: m.LiveRoom }))
);
export const Session = React.lazy(() =>
  import('@/pages/live/session').then((m) => ({ default: m.Session }))
);
export const Reception = React.lazy(() => import('@/pages/live/reception'));
export const Participants = React.lazy(() =>
  import('@/js/site/components/dashboards/Participants')
);
export const EntityListDashboard = React.lazy(() =>
  import('@/js/live/components/dashboards/EntityListDashboard')
);
export const EntitySlideShow = React.lazy(() =>
  import('@/js/live/components/dashboards/EntitySlideShow')
);
export const EntityViewFullscreen = React.lazy(() =>
  import('@/js/live/components/dashboards/EntityViewFullscreen')
);
export const Expo = React.lazy(() =>
  import('@/js/live/components/dashboards/Expo')
);
export const PollEmbed = React.lazy(() =>
  import('@/js/live/components/interact/PollEmbed')
);
export const DiscussionImageDashboard = React.lazy(() =>
  import('@/js/live/components/views/DiscussionImageDashboard').then((m) => ({
    default: m.DiscussionImageDashboard,
  }))
);
export const MingleLarge = React.lazy(() =>
  import('@/js/live/components/dashboards/MingleLarge').then((m) => ({
    default: m.MingleLarge,
  }))
);
